import type { TaskDto, TaskFormData } from "portfolio/types";

/**
 * Converts form data to a DTO for API requests.
 * Maps camelCase to snake_case for the backend.
 * Includes existing items (with id) for sync and new items (without id) for creation.
 */
export const taskFormDataToDto = (formData: TaskFormData): TaskDto => ({
  title: formData.title,
  description: formData.description,
  teacher_instructions:
    formData.teacherInstructions.length > 0
      ? formData.teacherInstructions
      : null,

  // Student selection (for scheduled tasks) / categorization (for library/public tasks)
  students_selected_by: formData.studentsSelectedBy,
  education_levels:
    formData.libraryEducationLevels.length > 0
      ? formData.libraryEducationLevels
      : formData.educationLevels,
  mentor_classes: formData.mentorClasses,
  lesson_groups: formData.lessonGroups,
  student_ids: formData.studentIds,

  // Planning - combine date and time
  start_date:
    formData.startDate && formData.startTime
      ? `${formData.startDate} ${formData.startTime}`
      : null,
  deadline:
    formData.deadlineDate && formData.deadlineTime
      ? `${formData.deadlineDate} ${formData.deadlineTime}`
      : null,

  // Selections
  tag_ids: formData.tagIds,
  lob_competence_ids: formData.lobCompetenceIds,
  skill_ids: formData.skillIds,

  // Settings
  is_required: formData.isRequired,
  attachment_required: formData.attachmentRequired,
  allow_task_ratings: formData.allowTaskRatings,
  auto_add_mentors_as_owners: formData.autoAddMentorsAsOwners,
  assessment_models: formData.assessmentModels,
  send_invites: formData.sendInvites,
  allow_send_reminder_before_deadline: formData.allowSendReminderBeforeDeadline,

  // Library settings
  add_to_library: formData.addToLibrary,
  template_name: formData.title || null,
  subjects: formData.subjects,

  // Content - include all items: existing (with id) for sync, new (without id) for creation
  links: formData.links.map((link) =>
    "id" in link
      ? { id: link.id, name: link.name, url: link.url }
      : { name: link.name, url: link.url },
  ),
  videos: formData.videos.map((video) =>
    "id" in video
      ? { id: video.id, name: video.name, url: video.url }
      : { name: video.name, url: video.url },
  ),
});
